import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Combobox from 'react-widgets/lib/Combobox';
import Loader from 'react-loader-spinner';

class Slots extends Component {
    constructor() {
        super();

        this.dialogClose = () => {
            this.setState({ hideupdateDialog: false, hideAddDialog: false, hideErrorAddingDialog: false, hideDeletePopup: false });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for update dialog component ok click
        this.Okbutton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchSlotDataApi()
                this.dialogClose();
            }
        }];
        this.addedButton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchSlotDataApi()
                this.dialogClose();
                this.setState({
                    disabled: false
                })
            }
        }];

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteSlotApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchSlotDataApi()
                this.setState({ disabled: false })

            }
        }];


        this.state = {
            disabled: false,
            pageNum: null,

            goBackToSlu: false,
            showButton: true,
            data: [
                {
                    id: '',
                    name: '',
                    displayName: '',
                    allowMultiple: '',
                    delayTemplateChecks: '',
                    deleteRow: false,
                    customType: '',
                    onlyEnglishValues: '',
                    lastOption: false,
                    sensitive: false
                }
            ],

            slotTypeList: [],
            customEntityTypeList: [],
            selectedslotType: '',
            selectedValueslotType: '',
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit2.png',
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            hideErrorAddingDialog: false,
            successResp: false
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }
    componentDidMount() {
        localStorage.setItem("intentId", this.props.location.state.intentId);

        if(this.props.location.state.pageNum != null && this.props.location.state.pageNum != undefined){
            this.state.pageNum = this.props.location.state.pageNum;
            this.setState(this.state);
        }

        setTimeout(() => {
            this.fetchSlotTypeApi();
            this.fetchCustomEntityTypeApi();
            this.fetchSlotDataApi();
        }, 300);

        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.props.history.push("/projectmgmt/nlutab")

        });

    }


    saveSlotApi = (props, e) => {
        var addController = this
        props.original.name =
            document.getElementById("name" + props.index).innerText.trim();
        props.original.displayName =
            document.getElementById("displayName" + props.index).innerText.trim();
        props.original.allowMultiple =
            document.getElementById("allowMultiple" + props.index).checked;
        props.original.delayTemplateChecks =
            document.getElementById("delayTemplateChecks" + props.index).checked;
        props.original.onlyEnglishValues = document.getElementById("onlyEnglishValueSwitch" + props.index).checked;
        props.original.lastOption = document.getElementById("lastOption" + props.index).checked;
        props.original.sensitive = document.getElementById("sensitive" + props.index).checked;
        addController.state.editedId = "-1";
        addController.setState(this.state);

        var customType = props.original.customType;
        if (customType == "None") {
            customType = null;
        }

        var validateResult = this.validateCells(
            props.original.name,
            props.original.displayName,
            props.original.slotType);

        if (validateResult == true) {
            var addedData = {
                name: props.original.name,
                displayName: props.original.displayName,
                allowMultiple: props.original.allowMultiple,
                slotType: props.original.slotType,
                delayTemplateChecks: props.original.delayTemplateChecks,
                intentId: localStorage.getItem("intentId"),
                customType: customType,
                onlyEnglishValues: props.original.onlyEnglishValues,
                lastOption: props.original.lastOption,
                sensitive: props.original.sensitive
            };


            $.ajax({
                url: "/api/slots",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(addedData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {

                        addController.notifyAdd();
                        addController.fetchSlotDataApi();
                        addController.state.disabled = false
                    } else {
                        addController.notifyError(res.result);
                    }
                },

                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            })

        }
    }
    notifyAdd() {
        toast.dismiss();
        this.setState({
            showButton: false
        })
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            Slot Added successfully</b>, {
            position: "top-center",

        });

    }
    notifyError(response) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            {response}</b>, {
            position: "top-center"
        });
    }



    updateSlotApi(props, e) {
        props.original.name = document.getElementById("name" + props.index).innerText.trim();
        props.original.displayName = document.getElementById("displayName" + props.index).innerText.trim();
        props.original.allowMultiple = document.getElementById("allowMultiple" + props.index).checked;
        props.original.delayTemplateChecks = document.getElementById("delayTemplateChecks" + props.index).checked;
        props.original.onlyEnglishValues = document.getElementById("onlyEnglishValueSwitch" + props.index).checked;
        props.original.lastOption = document.getElementById("lastOption" + props.index).checked;
        props.original.sensitive = document.getElementById("sensitive" + props.index).checked;

        var validateResult = this.validateCells(props.original.name,
            props.original.displayName, props.original.slotType);

        var customType = props.original.customType;
        if (customType == "None") {
            customType = null;
        }
        if (validateResult == true) {

            var updatedData = {
                name: props.original.name,
                displayName: props.original.displayName,
                allowMultiple: props.original.allowMultiple,
                delayTemplateChecks: props.original.delayTemplateChecks,
                id: props.original.id,
                slotType: props.original.slotType,
                intentId: localStorage.getItem("intentId"),
                customType: customType,
                onlyEnglishValues: props.original.onlyEnglishValues,
                lastOption: props.original.lastOption,
                sensitive: props.original.sensitive

            };
            var updatedDataController = this
            $.ajax({
                url: "/api/slots",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(updatedData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        updatedDataController.state.editedId = "-1";
                        updatedDataController.notifyUpdate();
                        updatedDataController.fetchSlotDataApi();
                    } else {
                        updatedDataController.notifyError(res.result);
                    }
                },

                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            })
        }
    }
    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Slot Updated Successfully</b>, {
            position: "top-center",

        });
    }
    deleteSlotApi = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;
        $.ajax({
            url: "/api/slots/" + id,
            async: false,
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {

                if (res.success === true) {
                    deleteApiViewController.setState({ deleteRow: true });
                    deleteConstructorVariables.setState({ hideDeletePopup: false });
                    deleteApiViewController.notifyDelete();

                    deleteRowViewController.splice(id, 1);
                    deleteConstructorVariables.fetchSlotDataApi();

                } else {
                    deleteConstructorVariables.notifyError(res.result);
                }
            },

            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });

    }

    notifyDelete() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
                content="" />&nbsp;&nbsp;Slot Deleted Successfully</b>, {
            position: "top-center",
        });

    }
    fetchSlotDataApi = () => {
        var fetchController = this;
        $.ajax({
            url: "/api/slots",
            async: false,
            method: 'GET',
            data: {
                intentId: localStorage.getItem("intentId")

            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;

                    fetchController.setState({
                        data: messages,
                        successResp: true,
                        disabled: false

                    })
                } else {
                    fetchController.setState({

                        successResp: false

                    })
                    fetchController.notifyError(res.result);
                }
            },

            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });

    }

    fetchSlotTypeApi = () => {
        let slotTypeController = this;
        $.ajax({
            url: "/api/slotTypes",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    for (var i = 0; i < res.result.length; i++) {
                        slotTypeController.state.
                            slotTypeList.push(res.result[i].name)
                    }
                }
                else {
                    slotTypeController.notifyError(res.result);
                }
            },

            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    fetchCustomEntityTypeApi = () => {
        let slotTypeController = this;
        $.ajax({
            url: "/api/custom-entity-type",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            data: { projectId: localStorage.getItem('currentProjectId') },
            success: function (res) {
                if (res.success === true) {
                    slotTypeController.state.
                        customEntityTypeList.push("None")
                    for (var i = 0; i < res.result.length; i++) {
                        slotTypeController.state.
                            customEntityTypeList.push(res.result[i].typeName)
                    }
                }
                else {
                    slotTypeController.notifyError(res.result);
                }
            },

            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }


    validateCells(name, displayName, slotType) {
        if ((name == "" || displayName == "" || slotType == null)) {
            this.notifyMsgFieldEmpty();
            return false;
        }
        else {
            return true;
        }

    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    addRow = (data) => {
        var rowController = this;
        if (rowController.state.pageNum != 0) {
            rowController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            name: '',
            displayName: '',
            allowMultiple: '',
            delayTemplateChecks: '',
            slotType: this.state.slotType,
        });
        this.setState({
            data: this.state.data,
            disabled: true
        })
    }

    makeCelleditable(props, e) {
        this.markAsBeingEdited(props.original.id);
    }
    markAsBeingEdited(id) {

        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }
    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchSlotDataApi()
        this.setState({ disabled: false })
    }


    comboBoxHandleChange = (props, e) => {
        props.original.slotType = e;
        this.setState(this.state);
    }

    customEntityComboBoxHandleChange = (props, e) => {
        props.original.customType = e;
        this.setState(this.state);
    }

    nameHandleChange(props, event) {
        props.original.name = document.getElementById("name" + props.index).innerText;

        this.setState(this.state);
    }
    displayNameHandleChange(event, props) {

        props.original.displayName = document.getElementById("displayName" + props.index).innerText;
        this.setState(
            this.state);
    }
    allowMultipleNameHandleChange(event, props) {

        props.original.allowMultiple = event;
        this.setState(
            this.state);
    }
    delayTempNameHandleChange(event, props) {

        props.original.delayTemplateChecks = event;
        this.setState(
            this.state);
    }

    templates = (props, e) => {
        this.props.history.push({
            pathname: '/projectmgmt/slu-template',
            state: {
                stateSlotId: props.original.id,
                slotName: props.original.name,
                intentName: this.props.location.state.intentName,
                pageNum: this.state.pageNum
            }
        });

        this.setState(this.setState)
    }
    prompts = (props, e) => {
        this.props.history.push({
            pathname: '/projectmgmt/slu-prompt',
            state: {
                stateSlotId: props.original.id,
                pageNum: this.state.pageNum
            }
        });

        this.setState(this.setState)
    }
    goBack = () => {
        this.props.history.push({
            pathname: "/projectmgmt/nlutab",
            state: { goBackToSlu: true }

        });
    }
    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    render() {
        const { data } = this.state
        const columns = [
            {
                Header: <b>Name</b>,
                accessor: 'name',
                sortable: false,
                Cell: props =>
                (<div
                    Align="left" className="input"
                    style={{
                        padding: '8px', width: '98%', borderBottom: 'none',
                        border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
                            '1px solid #D2D4DC' : 'none', borderRadius:
                            (props.original.id == undefined) ? '2px' : 'none', paddingLeft: '2px'
                    }}
                    suppressContentEditableWarning
                    contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}

                    onBlur={(e) => this.nameHandleChange(props, e)}
                    type="text" id={"name" + props.index} defaultValue={props.original.name}>
                    {props.original.name}
                </div>)
            },
            {
                Header: <b>Display Name</b>,
                accessor: 'displayName',
                sortable: false,

                Cell: props =>
                (<div
                    Align="left" className="input"
                    style={{
                        padding: '8px', width: '98%', borderBottom: 'none',
                        border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
                            '1px solid #D2D4DC' : 'none', borderRadius:
                            (props.original.id == undefined || props.original.id == this.state.editedId) ? '2px' : 'none', paddingLeft: '2px'
                    }}
                    contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}

                    onBlur={e => this.displayNameHandleChange(e, props)}
                    type="text" id={"displayName" + props.index} defaultValue={props.original.id == undefined ? "" :
                        props.original.displayName}
                >{props.original.displayName}</div>)
            },
            {
                Header: <b>Slot Type</b>,
                accessor: 'slotType',
                width: 100,
                sortable: false,
                Cell: props => {
                    return (
                        <div className="container-fluid"  >
                            <Combobox

                                data={this.state.slotTypeList}
                                defaultValue={props.original.slotType}
                                visible="true"
                                textField='name'
                                caseSensitive={false}
                                minLength={1}
                                style={{ border: 'none', borderBottom: 'none' }}
                                filter='contains'
                                id={"slotType" + props.index.id}
                                onSelect={(e) => this.comboBoxHandleChange(props, e)}
                                disabled={(props.original.id == undefined) ? false : props.original.id != this.state.editedId}

                            />
                        </div>
                    )
                },
            },
            {
                Header: <b>Custom Entity Type</b>,
                accessor: 'customEntityType',
                width: 150,
                sortable: false,
                Cell: props => {
                    return (
                        <div className="container-fluid"  >
                            <Combobox
                                data={this.state.customEntityTypeList}
                                defaultValue={props.original.customType}
                                visible="true"
                                textField='name'
                                caseSensitive={false}
                                minLength={1}
                                style={{ border: 'none', borderBottom: 'none' }}
                                filter='contains'
                                id={"customEntityType" + props.index.id}
                                onSelect={(e) => this.customEntityComboBoxHandleChange(props, e)}
                                disabled={(props.original.id == undefined) ? false : props.original.id != this.state.editedId}

                            />
                        </div>
                    )
                },
            },
            {
                Header: <b>Allow Multiple</b>,
                accessor: 'allowMultiple',
                width: 100,
                sortable: false,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <label class="switch" style={{ marginTop: '5px' }}>
                                <input type="checkbox"
                                    id={"allowMultiple" + props.index}
                                    defaultChecked={props.original.allowMultiple}
                                    disabled={(props.original.id == null) ? false : props.original.id != this.state.editedId}
                                />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            },
            {
                Header: <b>Delay Templates</b>,
                accessor: 'delayTemplateChecks',
                width: 100,
                sortable: false,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <label class="switch" style={{ marginTop: '5px' }}>
                                <input type="checkbox"
                                    id={"delayTemplateChecks" + props.index}
                                    defaultChecked={props.original.delayTemplateChecks}
                                    disabled={(props.original.id == null) ? false : props.original.id != this.state.editedId}
                                />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            },
            {
                Header: <b> Only English Value </b>,
                accessor: 'onlyEnglishValues',
                sortable: false,
                width: 100,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <label class="switch" style={{ marginTop: '5px' }}>
                                <input type="checkbox"
                                    id={"onlyEnglishValueSwitch" + props.index}
                                    defaultChecked={props.original.onlyEnglishValues}
                                    disabled={(props.original.id == null) ? false : props.original.id != this.state.editedId} />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            },



            {
                Header: <b> Last Option </b>,
                accessor: 'lastOption',
                sortable: false,
                width: 100,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <label class="switch" style={{ marginTop: '5px' }}>
                                <input type="checkbox"
                                    id={"lastOption" + props.index}
                                    defaultChecked={props.original.lastOption}
                                    disabled={(props.original.id == null) ? false : props.original.id != this.state.editedId} />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            },
            {
                Header: <b> Sensitive </b>,
                accessor: 'sensitive',
                sortable: false,
                width: 100,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <label class="switch" style={{ marginTop: '5px' }}>
                                <input type="checkbox"
                                    id={"sensitive" + props.index}
                                    defaultChecked={props.original.sensitive}
                                    disabled={(props.original.id == null) ? false : props.original.id != this.state.editedId} />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            },
            {
                Header: <b>Action</b>,
                accessor: 'action',
                width: 450,

                sortable: false,
                Cell: props => (
                    <div id="action">
                        {/* edit button */}
                        <div>
                            <p>
                                <button className="btn2 table-action-button"
                                    onClick={(e) => this.templates(props, e)}
                                    hidden={(props.original.id == undefined) ? true : false}>
                                    Templates</button>
                                <button className="btn2 table-action-button "
                                    onClick={(e) => this.prompts(props, e)}

                                    hidden={(props.original.id == undefined) ? true : false}>
                                    Prompts</button>

                                <button
                                    onClick={(e) => {
                                        (props.original.id == null) ?
                                            this.saveSlotApi(props, e) :
                                            (props.original.id == this.state.editedId) ?
                                                this.updateSlotApi(props, e) :
                                                this.makeCelleditable(props, e);
                                    }}



                                    style={{ backgroundColor: "#ffffff", border: "none" }}>
                                    <img className="img-responsive"
                                        style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}

                                        title={(props.original.id == undefined) ||
                                            (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                                        src={(props.original.id == null) ?
                                            this.saveImageSrc : ((props.original.id != this.state.editedId) ?
                                                this.editImageSrc : this.saveImageSrc)}

                                    /></button>
                                <button
                                    onClick={() => {
                                        (props.original.id) === undefined ?
                                            this.fetchSlotDataApi() :
                                            this.setState({
                                                hideDeletePopup: true, deletePropIndex: props.index,
                                                propsId: props.original.id
                                            })
                                    }}
                                    style={{ backgroundColor: "#ffffff", border: "none" }}>
                                    <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                        style={{
                                            marginTop: '6px',

                                            backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                        }}
                                        title="Delete"

                                    /></button>
                            </p>
                        </div>
                    </div>
                ),
            },
        ]
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={this.state.successResp ? false : true}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />
                <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }}>
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    {/* for Combobox styling */}
                    <link rel="stylesheet" href="./assets/css/combobox-style.css" />
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="assets/css/react-table-height.css" />
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />
                    <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />

                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-2" style={{ marginTop: '16px' }}>
                                <img src="./assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBack}
                                />
                            </div>
                            <div className="col-sm-8">
                                <h6 className="nav-item" style={{ color: '#282a65', marginLeft: '202px', marginTop: '18px' }}>
                                    Slots for {this.props.location.state.intentName}</h6>

                            </div>
                            {/* Add button and refresh button*/}
                            <div className="col-sm-2" Align='right'>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow} >
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData} className="btn action-button" title="Refresh">
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>

                        </div>
                    </div>
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12 ">
                                    <div className="card">

                                        <ReactTable
                                            data={data}
                                            columns={columns}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            onPageChange={this.onPageChange}
                                            page={this.state.pageNum}



                                        />
                                    </div>
                                    <ToastContainer className="Toast-at-center" />


                                    {/*Dialog Component For Deletion Confirmation*/}
                                    <DialogComponent width='400px' animationSettings={this.settings}
                                        header='Slot' showCloseIcon={true} buttons={this.buttons}
                                        ref={dialog => this.dialogInstance = dialog}
                                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                        <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                            content="" />&nbsp;Do you want to delete the Slot?<br />Note: Press 'Yes' to delete or press 'No' to decline.


                                    </DialogComponent>


                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        )

    }
}

export default Slots


// WEBPACK FOOTER //
// ./src/projectmgmt/nlu/intent/Slots.js